// Salmon line-art accents extracted from EventsPage.

export function PromiseDoodle({ index }: { index: number }) {
  const doodles = [
    // Coin / free
    <svg key={0} width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle
        cx="24"
        cy="24"
        r="18"
        stroke="#FFA07A"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeDasharray="2 3"
      />
      <text
        x="24"
        y="30"
        textAnchor="middle"
        fontSize="20"
        fill="currentColor"
        fontFamily="Plus Jakarta Sans, sans-serif"
        fontStyle="italic"
      >
        £
      </text>
    </svg>,
    // Person walking
    <svg key={1} width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="10" r="4" stroke="#FFA07A" strokeWidth="2.5" />
      <path
        d="M24 14 L24 30 M24 30 L16 42 M24 30 L32 42 M16 22 L32 22"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>,
    // Two figures
    <svg key={2} width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle cx="16" cy="14" r="4" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="32" cy="14" r="4" stroke="#FFA07A" strokeWidth="2.5" />
      <path
        d="M16 18 L16 36 M32 18 L32 36 M16 26 L32 26"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>,
    // Speech bubble / no
    <svg key={3} width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path
        d="M8 12 Q8 8 12 8 L36 8 Q40 8 40 12 L40 28 Q40 32 36 32 L20 32 L12 40 L14 32 L12 32 Q8 32 8 28 Z"
        stroke="#FFA07A"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M16 20 L32 20"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>,
  ];
  // text-ink drives the SVGs' `currentColor` strokes/fills so the ink line-art
  // flips with the theme (salmon accents stay literal).
  return (
    <div className="flex-shrink-0 mt-1 text-ink">
      {doodles[index] ?? doodles[0]}
    </div>
  );
}

export function SquiggleUnderline() {
  return (
    <svg
      className="absolute -bottom-3 left-0 w-full"
      viewBox="0 0 300 12"
      preserveAspectRatio="none"
      aria-hidden
    >
      <path
        d="M2 6 Q 30 0, 60 6 T 120 6 T 180 6 T 240 6 T 298 6"
        stroke="#FFA07A"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
